import axios from 'axios';

export const API_BASE = process.env.REACT_APP_API_URL ||
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
    ? 'http://localhost:8000'
    : `http://${window.location.hostname}:8000`);

const api = axios.create({
  baseURL: API_BASE,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auto-refresh token: se scade entro 7 giorni, rinnova automaticamente
let isRefreshing = false;
const tryRefreshToken = async () => {
  if (isRefreshing) return;
  const token = localStorage.getItem('token');
  if (!token) return;
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const exp = payload.exp * 1000;
    const seitGiorni = 7 * 24 * 60 * 60 * 1000;
    if (exp - Date.now() < seitGiorni) {
      isRefreshing = true;
      const res = await api.post('/auth/refresh');
      if (res.data?.access_token) {
        localStorage.setItem('token', res.data.access_token);
        localStorage.setItem('impero_jwt_token', res.data.access_token); // sync bridge estensione
      }
      isRefreshing = false;
    }
  } catch { isRefreshing = false; }
};
// Controlla al caricamento e ogni 6 ore
tryRefreshToken();
setInterval(tryRefreshToken, 6 * 60 * 60 * 1000);

// Track 401 errors — solo logout dopo multipli 401 consecutivi (evita logout per errori DB temporanei)
let consecutive401 = 0;
let isRedirecting = false;

api.interceptors.response.use(
  (response) => {
    // Reset contatore su qualsiasi risposta OK
    consecutive401 = 0;
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      const url = error.config.url || '';
      // Ignora endpoint di auth
      if (url.includes('/auth/login') || url.includes('/auth/register') || url.includes('/auth/callback') || url.includes('/auth/refresh')) {
        return Promise.reject(error);
      }
      consecutive401++;
      // Solo dopo 3 errori 401 consecutivi → verifica se il token è davvero invalido
      if (consecutive401 >= 3 && !isRedirecting) {
        // Ultimo tentativo: verifica con /auth/me prima di fare logout
        const token = localStorage.getItem('token');
        if (!token) {
          isRedirecting = true;
          window.location.replace('/login');
        } else {
          // Prova una chiamata diretta a /auth/me
          fetch(`${api.defaults.baseURL}/auth/me`, {
            headers: { 'Authorization': `Bearer ${token}` }
          }).then(res => {
            if (res.status === 401 || res.status === 403) {
              // Token davvero invalido → logout
              isRedirecting = true;
              localStorage.removeItem('token');
              localStorage.removeItem('impero_jwt_token'); // sync bridge estensione
              window.location.replace('/login');
            } else {
              // Token valido, errori temporanei — reset
              consecutive401 = 0;
            }
          }).catch(() => {
            // Errore di rete, non fare logout
            consecutive401 = 0;
          });
        }
      }
    }
    return Promise.reject(error);
  }
);

export default api;
